module.exports = __webpack_public_path__ + "img/9F.7eee82ac.png";